import * as React from 'react';
import styles from './no-value-dash.scss';

export const NoValueDash = () => (
  <div className={`no-value ${styles.dash}`}>&ndash;</div>
);
